import { Price } from '@modules/ticket-fares-store';
import { TicketType } from './ticket-type.enum';
import { CustomerTypeIds } from './customer-type.enum';

export interface ITicketDescriptionFields {
  [index: number]: ITicketDescriptionEntry;
}

export interface ITicketDescriptionEntry {
  /** TicketType AKA bundle type */
  ticketType: TicketType;
  title: string;
  /** Summary of ticket selector-style categories */
  description: string;
  /** Identify if Adult, Child or Student type */
  customerTypeId: CustomerTypeIds;
  customerType: string;
  travelMethod: string;
  travelTime: string;
  zone: string;
  prices: Price[];
  isDirectDebit: boolean;
  alias?: string;
  noDays: number;
  termDateFrom?: string;
  termDateTo?: string;
  mTicketID?: string;
  swiftTicketID?: string;
}
